export default __webpack_public_path__ + "static/media/PL.eafd3ed4.svg";